import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSetActionButtons } from "../services/ActionButtonsContext";
import { IconPlus } from "@tabler/icons-react";
import { useGetAllQuestionsForSurvey, useGetSurveyById } from "../api/survey";
import QuestionsTable from "../components/Surveys/QuestionsTable";
import { usePageTitle } from "../services/HeaderTitleContext";

function SurveyQuestions() {
  const { id } = useParams();
  const data = useGetAllQuestionsForSurvey(id);
  const { data: survey } = useGetSurveyById(id);

  usePageTitle(survey?.title ? `Questions - ${survey.title}` : null);

  const actions = useMemo(
    () => [
      {
        label: "Create",
        icon: <IconPlus />,
        navigate: `./surveys/${id}/questions/create`,
      },
    ],
    [id]
  );

  useSetActionButtons(actions);

  return <QuestionsTable data={data} isLoading={data.isLoading} />;
}

export default SurveyQuestions;
